import type CalendarEventData from '../store/schema/CalendarEventData';
import getCalendarEventData from '../selectors/getCalendarEventData';
import getViewState from '../selectors/getViewState';

export default function saveSchedulingAssistantChanges(
    viewStateId: string,
    callSaveAction: (finalState: CalendarEventData, isAllDayEventExplicitlySet: boolean) => void
) {
    callSaveAction(
        { ...getCalendarEventData(viewStateId) },
        getViewState(viewStateId).isAllDayEventExplicitlySet
    );
}
